import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import storage from './encryptedStorage';

export enum CompensationStoreEnum {
  LEGAL_HEIRS,
  DESIGNATED_BENEFICIARIES,
}

interface CompensationSelectionStoreStateI {
  compensationSelection?: CompensationStoreEnum;
  setCompensation: (compensationSelection: CompensationStoreEnum) => void;
}

const useCompensationSelectionStore = create<CompensationSelectionStoreStateI>()(
  persist(
    (set) => ({
      compensationSelection: undefined,
      setCompensation: (compensationSelection) => set({ compensationSelection }),
    }),
    {
      name: 'deceso-compensation-selection-storage',
      storage,
    }
  )
);

export default useCompensationSelectionStore;
